<script setup>
import { useTenkiNews } from '~/composables/useTenkiNews'

const tenkiNewsList = ref([])
const errmsg = ref()
const setNewsContents = async () => {
  const tmpTenkiNews = await useTenkiNews()
  drawTenkiNews(tmpTenkiNews)
}

const drawTenkiNews = function (list) {
  let msg
  const disp_list = (list) ? list.slice(0, 3) : null
  if (!disp_list) {
    msg = 'しばらくしてからアクセスしてください'
  } else {
    if (disp_list && disp_list.length == 0) {
      msg = 'ニュースはありません'
    }
  }
  tenkiNewsList.value = disp_list
  errmsg.value = msg
}

const onClickDetail = async () => {
  const url = 'https://www.sugotoku.docomo.ne.jp/cs/cpsite.html?url=https://dcsgtk.wni.co.jp/bousai/news/list.html'
  await navigateTo(url, { external: true })
}

onMounted(() => {
  setNewsContents()
})
</script>

<template>
  <div class="walking">
    <h2>人気ランキング</h2>
  </div>
  <CommonRankingCard />
  <div class="walking">
    <div
      v-if="tenkiNewsList"
      class="pt0"
    >
      <h2 class="flex items-center">
        <span class="block__heading">お天気ニュース</span>
      </h2>
      <ul class="list_pt01">
        <li
          v-for="item in tenkiNewsList"
          :key="item.tpid"
        >
          <a
            :href="'https://www.sugotoku.docomo.ne.jp/cs/cpsite.html?url=https://dcsgtk.wni.co.jp/s/news/detail.html?tpid='+ item.tpid"
          />
          <i class="thumb"><img :src="item.thumb_img"></i>
          <div class="txt">
            <p
              class="tit"
              v-text="item.title"
            />
            <div class="info">
              <p
                class="time"
                v-text="item.edit_tstr"
              />
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
  <div class="linkList_group" />
  <p
    id="disp_more"
    class="btn_more"
  >
    <span @click="onClickDetail()">もっと見る</span>
  </p>
  <a
    class="walking__btn_maru"
    href="https://www.sugotoku.docomo.ne.jp/cs/cpsite.html?url=https://dcsgtk.wni.co.jp/s/"
    title="ウェザーニュースTOP"
  >
    <img
      src="https://dcsgtk.wni.co.jp/s/walking/images/icon_home.svg"
      alt="ウェザーニュースTOP"
      loading="lazy"
    > ウェザーニュースTOP
  </a>
  <div class="walking__footer">
    提供：株式会社ウェザーニューズ
  </div>
</template>

<style lang="scss" scoped>
.walking {
  margin-left: auto;
  margin-right: auto;
  max-width: 800px;
  h2 {
    color: #333;
    font-size: 18px;
    margin: 30px auto 15px;
    max-width: 800px;
    font-weight: bold;
    width: calc(100vw - 20px);
  }
}
.walking__disp_mores {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin: 0 auto;
  max-width: 800px;
  justify-content: center;
}
.walking__footer {
  margin-top: 30px;
  background-color: #fffcec;
  color: #493e01;
  text-align: center;
  font-size: 14px;
  padding: 30px 0;
  width: 100%;
}
.walking__btn_maru {
  align-items: center;
  background-color: #625713;
  border-radius: 15px;
  color: #fff;
  display: flex;
  font-size: 16px;
  gap: 5px;
  height: 30px;
  justify-content: center;
  margin: 15px auto;
  max-width: 800px;
  -webkit-text-decoration: underline dotted #fff;
  text-decoration: underline dotted #fff;
  text-underline-offset: 3px;
  width: calc(100vw - 20px);
  img {
    height: 20px;
    width: auto;
  }
}
.btn_more {
  display: block;
  width: 200px;
  margin: 5px auto 20px;
  border: 1px solid #0B4199;
  border-radius: 4px;
  span {
    text-align: center;
    padding: 10px;
    display: block;
    color: #fff;
    font-weight: bold;
    font-size: 14px;
    line-height: 1em;
    background-color: #0B4199;
  }
}
.list_pt01 {
  margin: 5px;
}
.list_pt01 li {
  padding: 6px;
  position: relative;
  border-bottom: 1px solid #606060;
}
.list_pt01 a {
  display: block;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.list_pt01 .thumb {
  width: 95px;
  height: 70px;
  display: table-cell;
}
.list_pt01 .thumb.all {
  height: 70px;
}
.list_pt01 .txt {
  padding-left: 10px;
  display: table-cell;
  padding-right: 5px;
  vertical-align: top;
}
.list_pt01 .txt .tit {
  color: #000;
  font-weight: 600;
  line-height: 1.4em;
  font-size: 16px;
}
.list_pt01 .txt .info {
  margin-top: 5px;
}
.list_pt01 .txt .info * {
  color: #606060;
  font-size: 12px;
  line-height: 1em;
}
.thumb.all {
  overflow: hidden;
}
.thumb.all img {
  width: auto;
}
.thumb img {
  width: 100%;
}
</style>
